import {observer} from 'mobx-react-lite'
import React, {useState} from 'react'
import {Lang} from 'yougile-lang'
import {logger} from 'yougile-util'
import {Button} from '@components/common/base/buttons'
import {Input} from '@components/common/base/input'
import {Loader} from '@components/common/base/loader'
import {ErrorBoundary} from '@components/common/error-boundary/error-boundary'
import {cn} from '@containers/html-utils'
import {
  RegisterContext,
  RegisterStore,
  useRegisterStore
} from './register-store'

export const Register = () => {
  const [registerStore] = useState(() => new RegisterStore())

  return (
    <ErrorBoundary
      silent
      onError={e => logger.error('register error ' + e.message)}
    >
      <RegisterContext.Provider value={registerStore}>
        <RegisterBase />
      </RegisterContext.Provider>
    </ErrorBoundary>
  )
}

// eslint-disable-next-line max-lines-per-function
const RegisterBase = observer(() => {
  const [state, store] = useRegisterStore()

  return (
    <div className="login register">
      {state.stage === 'error' && (
        <div className="register-page-error">
          <i className="fa fa-warning" />
          {Lang.msg.recoveryInvalidLink}
        </div>
      )}

      {(state.stage === 'wait' || state.stage === 'wait-ready') && (
        <div className="register__wait">
          <div className="register__wait__header">
            {state.stage === 'wait' && (
              <div>
                <div className="register__wait__progress">
                  <div className="register__wait__progress-bar-cnt">
                    <div
                      className="register__wait__progress-bar"
                      style={{width: state.progress + '%'}}
                    />
                    <div className="register__wait__progress-num">
                      {state.progress}%
                    </div>
                  </div>
                </div>
                <div className="register__wait__progress-hint">
                  {state.progressLabel}…
                </div>
              </div>
            )}

            {state.stage === 'wait-ready' && (
              <div>
                <div className="register__wait__done-label">
                  Готово! Ваша компания настроена.
                </div>
                <div className="register__wait__done-btn" onClick={store.enter}>
                  Зайти в систему
                </div>
              </div>
            )}
          </div>
          <div className="register__wait__title">
            Всего 60 секунд для быстрого знакомства с системой!
          </div>
          <div className="register__wait__video">
            <div id="y-player" className="register__player" />
            {state.muted && (
              <div
                className="register__wait__unmute-cnt"
                onClick={store.unmute}
              >
                <div className="register__wait__unmute">Включить звук</div>
              </div>
            )}
          </div>
          <div className="register__wait__link">
            <a
              href="https://youtu.be/itz6z5rmfVA"
              target="_brank"
              rel="noopener"
            >
              youtu.be/itz6z5rmfVA
            </a>
          </div>
        </div>
      )}

      {state.stage === 'form' && (
        <div className="login-wnd">
          <div className="register__title">{Lang.msg.reg.finishTitle}</div>
          <div className="mt-14 mr-0">
            {/* Hidden email field (for browsers to remember login/pass) */}
            <label
              className={cn(
                'login-form-field hidden',
                state.initialEmail && 'fixed-input'
              )}
              style={{display: 'none'}}
            >
              <span className="login-form-label">{Lang.msg.email}:</span>
              <Input
                type="email"
                className={cn(
                  'login-form-input',
                  state.initialEmail && 'fixed-input'
                )}
                name="username"
                disabled={state.regForm.wait}
                defaultValue={state.regForm.email}
                onChange={x => store.setEmail(x.text)}
                onKeyUp={e => store.keyUp('email', e)}
                placeholder={Lang.msg.emailPl}
                hasError={store.showInvalidEmail()}
              />
            </label>
            {/* / */}

            <label
              className={cn(
                'login-form-field',
                state.regForm.typing !== 'name' &&
                  state.regForm.name &&
                  !store.isNameCorrect() &&
                  'error',
                state.regForm.typing !== 'name' && store.isNameCorrect() && 'ok'
              )}
            >
              <span className="login-form-label">{Lang.msg.name}:</span>
              <Input
                type="text"
                className="login-form-input"
                name="display"
                disabled={state.regForm.wait}
                defaultValue={state.regForm.name}
                onChange={x => store.setName(x.text)}
                onKeyUp={e => store.keyUp('name', e)}
                placeholder={Lang.msg.namePl}
                autoFocus
                hasError={store.showInvalidName()}
              />
            </label>

            {state.withPhone && (
              <>
                <label
                  className={cn(
                    'login-form-field',
                    state.regForm.typing !== 'company' &&
                      state.regForm.company &&
                      !store.isCompanyNameCorrect() &&
                      'error',
                    state.regForm.typing !== 'company' &&
                      store.isCompanyNameCorrect() &&
                      'ok'
                  )}
                >
                  <span className="login-form-label">
                    {Lang.msg.reg.company}:
                  </span>
                  <Input
                    type="text"
                    className="login-form-input"
                    name="display"
                    disabled={state.regForm.wait}
                    defaultValue={state.regForm.company}
                    onChange={x => store.setCompany(x.text)}
                    onKeyUp={e => store.keyUp('company', e)}
                    placeholder={Lang.msg.reg.companyPl}
                    hasError={store.showInvalidCompany()}
                  />
                </label>
                <label className="login-form-field">
                  <span className="login-form-label">{Lang.msg.phone}:</span>
                  <Input
                    type="text"
                    className="login-form-input"
                    name="phone"
                    disabled={state.regForm.wait}
                    defaultValue={state.regForm.phone}
                    onChange={x => store.setPhone(x.text)}
                    onKeyUp={e => store.keyUp('phone', e)}
                    placeholder={Lang.msg.phonePl}
                    hasError={store.showInvalidPhone()}
                  />
                </label>
              </>
            )}
          </div>

          <form className="login-form">
            <label
              className={cn(
                'login-form-field hidden',
                state.initialEmail && 'fixed-input'
              )}
              style={{display: 'none'}}
            >
              <span className="login-form-label">{Lang.msg.email}:</span>
              <Input
                type="email"
                className={cn(
                  'login-form-input',
                  state.initialEmail && 'fixed-input'
                )}
                name="username"
                disabled={state.regForm.wait}
                defaultValue={state.regForm.email}
                onChange={x => store.setEmail(x.text)}
                onKeyUp={e => store.keyUp('email', e)}
                placeholder={Lang.msg.emailPl}
                hasError={store.showInvalidEmail()}
              />
            </label>

            <label
              className={cn(
                'login-form-field',
                state.regForm.typing !== 'password' &&
                  state.regForm.password &&
                  !store.isPasswordCorrect() &&
                  'error',
                state.regForm.typing !== 'password' &&
                  store.isPasswordCorrect() &&
                  'ok'
              )}
            >
              <span className="login-form-label">{Lang.msg.password}:</span>
              <Input
                type="password"
                className="login-form-input"
                name="password"
                disabled={state.regForm.wait}
                defaultValue={state.regForm.password}
                onChange={x => store.setPassword(x.text)}
                onKeyUp={e => store.keyUp('password', e)}
                placeholder={Lang.msg.passwordPl}
                hasError={store.showInvalidPass()}
              />
            </label>
            <Button
              className={cn('m-auto mt-24', state.regForm.wait && 'disabled')}
              onClick={store.submit}
              disabled={state.isPending}
            >
              {state.isPending && state.isSoftPending && (
                <span className="mr-8">
                  <Loader size="xsmall" />
                </span>
              )}
              <span>{Lang.msg.reg.enter}</span>
            </Button>
            {state.regForm.error && (
              <div className="login-error">
                <i className="fa fa-warning" />
                <span>{state.regForm.error}</span>
              </div>
            )}
          </form>
        </div>
      )}
    </div>
  )
})
